import { Form } from 'components/Wizards/Form/Form'
import Styles from '../../Source.module.scss'
import { Field } from 'components/Wizards/Field/Field'
import { replace, startCase } from 'lodash'
import { DropZone } from '../DropZone/DropZone'
import { useLastUsedLanguage } from 'hooks/queries/useLastUsedLanguage'
import { LanguageInput } from 'components/Wizards/Wizard/Form/LanguageInputField/LanguageInput'
import { useState } from 'react'
import { FileItem } from '../FileItem/FileItem'

interface Props {
  sourceType: 'audio' | 'video'
  file: File | undefined
  setFile: (file: File | undefined) => void
}

const formatString = (str: string): string => {
  return startCase(replace(str, /[_-]/g, ' '))
}

const fieldLabel = (sourceType: 'audio' | 'video'): string => {
  return `Upload your ${sourceType} file so that Blaze can create a transcript and repurpose that transcript into any other content format.`
}

export const AudioOrVideoSource = ({ sourceType, file, setFile }: Props) => {
  const defaultLanguageQuery = useLastUsedLanguage()
  const [language, setLanguage] = useState<string>(defaultLanguageQuery?.data?.language || 'English')

  const handleDrop = (acceptedFiles: File[]) => {
    setFile(acceptedFiles[0])
  }

  return (
    <Form.Fields className={Styles.container}>
      <Field label={fieldLabel(sourceType)} isRequired>
        {file ? (
          <FileItem file={file} onRemove={() => setFile(undefined)} type={sourceType} />
        ) : (
          <DropZone onDrop={handleDrop} inputType={sourceType} />
        )}
      </Field>
      <Field label={`Language of the ${formatString(sourceType)}`}>
        <div className={Styles.languageInput}>
          <LanguageInput languageValue={language} onLanguageChange={setLanguage} />
        </div>
      </Field>
    </Form.Fields>
  )
}
